import { Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import ProductionVoices from "../../components/ProductionVoices/ProductionVoices";

export default function ProductionReadersView({ offers, production }) {
	const { t } = useTranslation();

	return (
		<>
			<Header as="h4" content={t("voices", "Voices")} />

			<ProductionVoices production={production} offers={offers} />
		</>
	);
}
